import { render, staticRenderFns } from "./STLPARES.vue?vue&type=template&id=abe70a0e"
import script from "./STLPARES.vue?vue&type=script&lang=js"
export * from "./STLPARES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports